export default class SortModes {
  static ID = "1";
  static NAME = "2";
  static CHECKED = "3";
}
